import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField } from "@material-ui/core"
import { useFormik } from "formik";
import * as yup from 'yup';
import { getGrupos, getTutoriasGrupalesEnlaces, insertar_tutoria_grupal_enlace, update_tutoria_grupal_enlace, } from '../../../services/alumnos';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { selectUsuarioSeleccionado } from '../../../redux/reducer/loginReducer';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { red } from '@material-ui/core/colors';

export const DialogTutoriaGrupalEnlaceForm = ({tutoriaGrupalEnlace, setTutorias, openModal, handleOpenModal}) => {
    const [grupos, setGrupos] = useState([])
    const [gruposSeleccionados, setGruposSeleccionados] = useState([])
    const [mostrarHelperTextGrupos, setMostrarHelperTextGrupos] = useState(false)

    const usuarioSeleccionado = useSelector(state => {
        return selectUsuarioSeleccionado(state);
    });

    useEffect(() => {

        getGrupos({usuario_id: usuarioSeleccionado.id}).then( (response) => {
            response.grupos && setGrupos(response.grupos)
        })

        if(tutoriaGrupalEnlace) {

            formik.setValues({
                grupo_id: tutoriaGrupalEnlace.grupo_id,
                url_video: tutoriaGrupalEnlace.url_video,
                url_adjunto: tutoriaGrupalEnlace.url_adjunto,
                url_presentacion: tutoriaGrupalEnlace.url_presentacion,
                descripcion: tutoriaGrupalEnlace.descripcion,
            })

        } else {
            
            formik.setValues({
                grupo_id: "",
                url_video: "",
                url_adjunto: "",
                url_presentacion: "",
                descripcion: "",
            })

        }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    /* -------------------------------------------------------------------------- */
    /*                                   Formik                                   */
    /* -------------------------------------------------------------------------- */
    const formik = useFormik({
        initialValues: {
            grupo_id: "",
            url_video: "",
            url_adjunto: "",
            url_presentacion: "",
            descripcion: "",
        },
        validationSchema: yup.object({
            grupo_id: tutoriaGrupalEnlace && yup.string().required("Campo requerido"),
            url_video: yup.string().required("Campo requerido"),
            url_adjunto: yup.string(),
            url_presentacion: yup.string(),
            descripcion: yup.string().required("Campo requerido"),
          }),
        onSubmit: (values) => {

          gruposSeleccionados.length === 0 && setMostrarHelperTextGrupos(true)

          if(tutoriaGrupalEnlace) {

              update_tutoria_grupal_enlace({
                  usuario_id: usuarioSeleccionado.id, 
                  tutoria_grupal_enlace_id: tutoriaGrupalEnlace.id,
                  campos:values 
              }).then( (response) => {
                  getTutoriasGrupalesEnlaces({ usuario_id: usuarioSeleccionado.id }).then((response) => {
                      response && setTutorias(response.tutorias)
                  });
              })
            handleOpenModal(false)

          } else {

              gruposSeleccionados.forEach( (grupo_id) => {

                values.grupo_id = grupo_id
                insertar_tutoria_grupal_enlace({
                    usuario_id: usuarioSeleccionado.id, 
                    campos: values
                }).then( (response) => {
                    getTutoriasGrupalesEnlaces({ usuario_id: usuarioSeleccionado.id }).then((response) => {
                        response && setTutorias(response.tutorias)
                    });
                })

              })
              handleOpenModal(false)
          }
        },
    });

    /* -------------------------------------------------------------------------- */
    /*                                   Return                                   */
    /* -------------------------------------------------------------------------- */
    return (
      <Dialog
        open={openModal}
        onClose={() => handleOpenModal(false)}
        maxWidth={"md"}
      >
        <form
          noValidate
          method="POST"
          enctype="multipart/form-data"
          autoComplete="off"
          onSubmit={formik.handleSubmit}
        >
          <DialogTitle>Nuevo Enlace</DialogTitle>
          <DialogContent style={{ width: "700px" }}>
            <Grid container>
              { !tutoriaGrupalEnlace && <Grid item sm={12} style={{marginBottom: 15}}>
                <div style={{ height: "300px" }}>
                  <DataGridPro
                    rows={grupos}
                    columns={[
                      {
                        field: "descripcion",
                        headerName: "Grupo",
                        width: 130,
                        flex: 1,
                      },
                    ]}
                    checkboxSelection
                    pagination
                    onRowSelectionModelChange={(rowSelecctionModel) => {
                      setGruposSeleccionados(rowSelecctionModel);

                      gruposSeleccionados.length >= 0 ? setMostrarHelperTextGrupos(false) : setMostrarHelperTextGrupos(true)
                    }}
                  />
                </div>
                { mostrarHelperTextGrupos && <FormHelperText style={{color: red[500]}} >Tienes que seleccionar al menos un grupo</FormHelperText>}
              </Grid>}

              { tutoriaGrupalEnlace && <Grid item sm={12}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel id="grupo_id-label">Grupo de alumnos</InputLabel>

                  <Select
                    labelId="grupo_id-label"
                    id="grupo_id"
                    name="grupo_id"
                    label="Grupo"
                    fullWidth
                    value={formik.values.grupo_id}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.grupo_id && Boolean(formik.errors.grupo_id)
                    }
                  >
                    {grupos &&
                      grupos.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.descripcion}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {/* <FormHelperText>{formik.touched.plantilla_id && formik.errors.plantilla_id}</FormHelperText> */}
                </FormControl>
              </Grid>}

              <Grid item sm={12}>
                <TextField
                  id="url_video"
                  name="url_video"
                  label="Video"
                  placeholder="Introduce la URL del video"
                  fullWidth
                  margin="normal"
                  value={formik.values.url_video}
                  onChange={formik.handleChange}
                  variant="outlined"
                  error={
                    formik.touched.url_video && Boolean(formik.errors.url_video)
                  }
                  //   helperText={
                  //     formik.touched.url_video && formik.errors.url_video
                  //   }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <TextField
                  id="url_presentacion"
                  name="url_presentacion"
                  label="Presentación"
                  placeholder="Introduce la URL de la presentación asociada"
                  fullWidth
                  margin="normal"
                  value={formik.values.url_presentacion}
                  onChange={formik.handleChange}
                  variant="outlined"
                  error={
                    formik.touched.url_presentacion &&
                    Boolean(formik.errors.url_presentacion)
                  }
                  helperText={
                    formik.touched.url_presentacion && formik.errors.url_presentacion
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <TextField
                  id="url_adjunto"
                  name="url_adjunto"
                  label="Adjunto"
                  placeholder="Introduce la URL del adjunto asociado"
                  fullWidth
                  margin="normal"
                  value={formik.values.url_adjunto}
                  onChange={formik.handleChange}
                  variant="outlined"
                  error={
                    formik.touched.url_adjunto &&
                    Boolean(formik.errors.url_adjunto)
                  }
                  helperText={
                    formik.touched.url_adjunto && formik.errors.url_adjunto
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item sm={12}>
                <TextField
                  id="descripcion"
                  name="descripcion"
                  label="Descripcion"
                  placeholder="Breve descripción del vídeo"
                  fullWidth
                  margin="normal"
                  value={formik.values.descripcion}
                  onChange={formik.handleChange}
                  variant="outlined"
                  error={
                    formik.touched.descripcion &&
                    Boolean(formik.errors.descripcion)
                  }
                  helperText={
                    formik.touched.descripcion &&
                    formik.errors.url_adjdescripcionunto
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleOpenModal(false)}>Cancelar</Button>
            <Button onClick={ () => {
              gruposSeleccionados.length === 0 && setMostrarHelperTextGrupos(true) 
              formik.submitForm()
            }}>
              {" "}
              {tutoriaGrupalEnlace ? "Actualizar enla" : "Crear enlace"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    );
}